module.exports = __webpack_public_path__ + "static/img/8.0c92a7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/8.png
// module id = N+Oh
// module chunks = 0